import { Card, CardContent, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';

export const ColumnPlaceholderSkeleton = memo(() => {
  return (
    <Card sx={{ height: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <CardContent>
        <Stack sx={{ maxWidth: '250px', alignItems: 'center' }} spacing={1}>
          <Skeleton variant="circular" height={40} width={40} />
          <Skeleton height={32} width={200} />
          <Skeleton height={24} width={300} />
          <Skeleton height={24} width={100} />
        </Stack>
      </CardContent>
    </Card>
  );
});
